// See also https://github.com/offerwiseteam/panelsites-v2/blob/develop/trackers.md

import { getAppMap } from 'config/app';
import { env } from 'config/env';

export const trackingConfig = getAppMap({
  queopinas: {
    fbId: '434566996955915',
    microsoftUetId: '331000397',
    twitterId: 'o4ccr',
    gtagId: 'UA-1646604-14',
    gtmIframeId: 'GTM-MGBNSKJ',
    tabolaId: 1164225,

    registration: {
      twitterTrackPid: 'o4cct',
      googleSendTo: [
        'AW-1072735680/63U6CKT27IcBEMDLwv8D',
        'AW-404271196/W7wFCImVlvwBENzg4sAB',
        'AW-404272168/R1XrCN7ElvICEKjo4sAB',
        'AW-404272168/yCS2CI2TrvICEKjo4sAB', // common
        'AW-629648936/SG-gCNKllvwBEKjcnqwC',
      ],
    },
  },

  voceopina: {
    fbId: '434566996955915',
    microsoftUetId: '331000398',
    twitterId: 'o4cdi',
    gtagId: 'UA-1646604-19',
    gtmIframeId: 'GTM-PWGGDCH',
    tabolaId: 1164225,

    registration: {
      twitterTrackPid: 'o4cdk',
      googleSendTo: [
        'AW-1072735680/th0UCKKC5gUQwMvC_wM',
        'AW-404271196/DtwyCKi4ovwBENzg4sAB',
        'AW-404272168/IjgTCNX9wfICEKjo4sAB',
        'AW-404272168/yCS2CI2TrvICEKjo4sAB', // common
        'AW-629648936/tgWUCMirovwBEKjcnqwC',
      ],
    },
  },

  quedices: {
    fbId: 'xxxxxxxxxxxxxxxxx',
    microsoftUetId: 'xxxxxxxxxxxxxxx',
    twitterId: 'xxxxxxxxxxxxxxxx',
    gtagId: 'UA-xxxxxxxxxxxxxxxxx-19',
    gtmIframeId: 'GTM-xxxxxxxxxxxxxxxx',
    tabolaId: 111111111111111,

    registration: {
      twitterTrackPid: 'xxxxxxxxxxxxxxxxx',
      googleSendTo: [
        'AW-xxxxxxxxxxxxxxxxxxxxxxxxxxx',
        'AW-xxxxxxxxxxxxxxxxxxxxxxxxxxx',
        'AW-xxxxxxxxxxxxxxxxxxxxxxxxxxx',
        'AW-xxxxxxxxxxxxxxxxxxxxxxxxxxx', // common
        'AW-xxxxxxxxxxxxxxxxxxxxxxxxxxx',
      ],
    },
  },
})[env.appId];
